import { render, staticRenderFns } from "./WelcomeSheet.vue?vue&type=template&id=57856ae7&scoped=true&"
import script from "./WelcomeSheet.vue?vue&type=script&lang=js&"
export * from "./WelcomeSheet.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSheet.vue?vue&type=style&index=0&id=57856ae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57856ae7",
  null
  
)

export default component.exports